// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1Lsp0","amount":"Amount_amount__3XAbd","tip":"Amount_tip__CSs-k","tipHeader":"Amount_tipHeader__A3EcF","tipsWrap":"Amount_tipsWrap__3Yn-3"};